export const HTTP_CODE = {
  UNPUBLISHED_SKILL: 2,
  NOT_ALLOWED_IP: 5,
  NOT_ASSIGNED_SKILL: 52,

  // HTTP STATUS CODE
  FORBIDDEN: 403,
};
